// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"dashboardContainer---XKBOF","dashboardContent":"dashboardContent---uhzaD"};